import { IconProps } from './types';

export function QuestionMark({ size = 24, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.38964 0.5C2.69336 0.5 0.5 2.69336 0.5 5.38964C0.5 5.94065 0.946555 6.3876 1.49795 6.3876C2.04935 6.3876 2.4959 5.94065 2.4959 5.38964C2.4959 3.79379 3.79418 2.49551 5.38964 2.49551C6.98511 2.49551 8.28339 3.79379 8.28339 5.38964C8.28339 6.30719 7.61966 6.92086 6.52633 7.82225C5.52562 8.64717 4.39169 9.58206 4.39169 11.0687V11.4966C4.39169 12.0476 4.83864 12.4945 5.38964 12.4945C5.94065 12.4945 6.3876 12.0476 6.3876 11.4966V11.0687C6.3876 10.5233 7.04068 9.98526 7.79624 9.36213C8.90257 8.45011 10.2793 7.315 10.2793 5.38964C10.2793 2.69336 8.08553 0.5 5.38964 0.5Z"
        fill="currentColor"
      />
      <path
        d="M5.38978 13.9401C4.68389 13.9401 4.11002 14.5143 4.11002 15.2202C4.11002 15.9261 4.68428 16.5 5.38978 16.5C6.09528 16.5 6.66954 15.9257 6.66954 15.2202C6.66954 14.5147 6.09528 13.9401 5.38978 13.9401Z"
        fill="currentColor"
      />
    </svg>
  );
}
